/**
 * Centralized icon components using Phosphor Icons (thin weight)
 */
import {
  AirplaneInFlight,
  Bed,
  Bus,
  Park,
  MapPinSimpleArea,
  HouseLine,
  IdentificationCard,
  BowlSteam,
  PuzzlePiece,
} from '@phosphor-icons/react';

// Default icon props
const defaultProps = {
  weight: 'thin',
};

// Event category icons
export function FlightIcon({ className, size = 24 }) {
  return <AirplaneInFlight className={className} size={size} {...defaultProps} />;
}

export function AccommodationIcon({ className, size = 24 }) {
  return <Bed className={className} size={size} {...defaultProps} />;
}

export function TransitIcon({ className, size = 24 }) {
  return <Bus className={className} size={size} {...defaultProps} />;
}

export function ActivityIcon({ className, size = 24 }) {
  return <Park className={className} size={size} {...defaultProps} />;
}

// Timezone icons
export function LocalTimezoneIcon({ className, size = 24 }) {
  return <MapPinSimpleArea className={className} size={size} {...defaultProps} />;
}

export function HomeTimezoneIcon({ className, size = 24 }) {
  return <HouseLine className={className} size={size} {...defaultProps} />;
}

// Expense category icons
export function TransportIcon({ className, size = 24 }) {
  return <Bus className={className} size={size} {...defaultProps} />;
}

export function VisasIcon({ className, size = 24 }) {
  return <IdentificationCard className={className} size={size} {...defaultProps} />;
}

export function FoodDrinkIcon({ className, size = 24 }) {
  return <BowlSteam className={className} size={size} {...defaultProps} />;
}

export function MiscellaneousIcon({ className, size = 24 }) {
  return <PuzzlePiece className={className} size={size} {...defaultProps} />;
}

// Helper to get icon component by category value
export function getCategoryIcon(category, props = {}) {
  const icons = {
    // Event categories
    flight: FlightIcon,
    accommodation: AccommodationIcon,
    transit: TransitIcon,
    activity: ActivityIcon,
    // Expense categories
    transport: TransportIcon,
    activities: ActivityIcon,
    food_drink: FoodDrinkIcon,
    visas: VisasIcon,
    miscellaneous: MiscellaneousIcon,
  };
  
  const IconComponent = icons[category] || MiscellaneousIcon;
  return <IconComponent {...props} />;
}

// Export raw Phosphor components for direct use
export {
  AirplaneInFlight,
  Bed,
  Bus,
  Park,
  MapPinSimpleArea,
  HouseLine,
  IdentificationCard,
  BowlSteam,
  PuzzlePiece,
};
